import { render } from "./Integration.vue?vue&type=template&id=4f7c3e18&scoped=true"
import script from "./Integration.vue?vue&type=script&lang=js"
export * from "./Integration.vue?vue&type=script&lang=js"

import "./Integration.vue?vue&type=style&index=0&id=4f7c3e18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7c3e18"]])

export default __exports__